import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldErrorComponent } from '../form-field-error/form-field-error.component';

@Component({
  selector: 'lib-form-input-group',
  styleUrls: ['form-input-group.component.scss'],
  templateUrl: './form-input-group.component.html',
  imports: [FormsModule, ReactiveFormsModule, FormFieldErrorComponent],
})
export class FormInputGroupComponent extends FieldBaseComponent {}
